import React, { FC } from 'react';
import AgentApplicationTable from '~/components/views/agent/AgentApplicationTable';

const Applications: FC = () => {
  return <AgentApplicationTable />;
};

export default Applications;
